import { useEffect, useState } from 'react';
import {
  Avatar, TableRow, TableHead, TableContainer, TableCell,
  TableBody, Table, Typography
} from '@mui/material';
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../services/api";
import HeaderSession from "../../utils/headerSession";
import Loading from "../../load/loading";
import Paginacao from "../../utils/paginacao";
import { useDispatch, useSelector } from 'react-redux';
import StatusEstabelecimento from '../../utils/status/statusEstabelecimento';
import RegisterAccess from '../../utils/registerAccess';
import { EstabelecimentosLicenciadosexcel } from '../exports/gerarelatorioexcel';
import { EstabelecimentosLicenciadospdf } from '../exports/gerarelatoriopdf';
import SearchEstabelecimento from '../../utils/searchEstabelecimento';
import { Paper } from '@mui/material';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  hover: { '&:hover': { backgroundColor: '#d2d6ff' }, cursor: 'pointer' }
}))

export default function EstabelecimentosLicenciados() {
  const classes = useStyles()
  const navigate = useNavigate()
  const [estabelecimentos, setEstabelecimentos] = useState(useSelector(state => state?.estabelecimentoLicenciados?.data) ?? '')
  const [configLista, setConfigLista] = useState(useSelector(state => state?.estabelecimentoLicenciados?.config) ?? '')
  const dispatch = useDispatch();
  const [perPage, setPerPage] = useState(40)
  const [order, setOrder] = useState('DESC')
  const [loading, setLoading] = useState(false);
  const [tipo, setTipo] = useState('');
  const [status, setStatus] = useState('Activo'); // novo estado para filtro de status
  const [provincia, setProvincia] = useState('');
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));

  useEffect(() => {
    setLoading(true)
    setEstabelecimentos('')

    api.get(`/estabelecimentos?page=${page}&perPage=${perPage}&sortBy=createdAt:${order}&status=${status}&provincia=${provincia}&tipoId=${tipo}`)
      .then(response => {
        setConfigLista(response.data);
        setEstabelecimentos((prevItems) => [...prevItems, ...response.data.estabelecimentos]);
      }).catch(err => { })
      .finally(() => setLoading(false))

    dispatch({
      type: 'estabelecimentoLicenciados',
      payload: { estabelecimentoLicenciados: estabelecimentos, config: configLista },
    });

  }, [status, page, perPage, order, tipo, status, provincia]); // adiciona status como dependência

  return (
    <>
      <RegisterAccess page={'lista de estabelecimentos licenciados'} />

      <HeaderSession
        title='ESTABELECIMENTOS LICENCIADOS'
        actions={true}
        handleExportExcel={() => EstabelecimentosLicenciadosexcel(estabelecimentos)}
        handleExportPDF={() => EstabelecimentosLicenciadospdf(estabelecimentos)}
      />

      {/* Passa o setStatus para o SearchEstabelecimento */}
      <SearchEstabelecimento
        setEstabelecimentos={setEstabelecimentos}
        setTipo={setTipo}
        setStatus={setStatus}
        status={status}
        setProvincia={setProvincia}
        placeholder={'Filtra por nome, número de processo..'}
      />

      {estabelecimentos &&
        <TableContainer sx={{ border: "1px black" }} component={Paper}>
          <Table sx={{ border: "1px", borderColor: "black" }}>
            <TableHead sx={{ backgroundColor: "#dcdede" }}>
              <TableRow>
                <TableCell ><Typography noWrap><strong>Imagem</strong></Typography></TableCell>
                <TableCell ><Typography noWrap><strong>Nome</strong></Typography></TableCell>
                <TableCell ><Typography noWrap><strong>Tipo</strong></Typography></TableCell>
                <TableCell ><Typography noWrap><strong>Número de Processo</strong></Typography></TableCell>
                <TableCell ><Typography noWrap><strong>Director Técnico</strong></Typography></TableCell>
                <TableCell ><Typography noWrap><strong>Provincia</strong></Typography></TableCell>
                <TableCell ><Typography noWrap><strong>Estado</strong></Typography></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {estabelecimentos.map((estabelecimento) => (
                <TableRow key={estabelecimento._id} className={classes.hover} onClick={() => navigate(`/admin/gestor-licenciados/${estabelecimento?._id}`)} title={estabelecimento?.nome}>
                  <TableCell component="th" scope="row">
                    <Avatar variant='square' src={estabelecimento?.logo} alt={estabelecimento?.nome} />
                  </TableCell>
                  <TableCell>{estabelecimento?.nome}</TableCell>
                  <TableCell>{estabelecimento?.tipo?.designacao}</TableCell>
                  <TableCell>{estabelecimento?.numeroProcesso}</TableCell>
                  <TableCell>{estabelecimento?.directorTecnico?.dadosPessoais?.nome}</TableCell>
                  <TableCell>{estabelecimento?.provincia}</TableCell>
                  <TableCell>
                    <StatusEstabelecimento status={estabelecimento?.status} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <Paginacao
            configLista={configLista}
            lista={estabelecimentos}
            page={page}
            setPage={setPage}
            setPerPage={setPerPage}
            setOrder={setOrder}
          />
        </TableContainer>
      }

      {loading && <Loading />}
    </>
  )
}
